import { useQuery } from '@tanstack/react-query';
import { listAiMessages } from '../api/messages';
import { aiQueryKeys } from './query-keys';

export const useThreadMessages = (threadId: string | null) =>
  useQuery({
    queryKey: threadId ? aiQueryKeys.threadMessages(threadId) : [...aiQueryKeys.all, 'threads', 'messages-null'],
    queryFn: () => listAiMessages(threadId!),
    enabled: Boolean(threadId),
    staleTime: 60_000,
  });
